var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutocompleteBase',_vm._g(_vm._b({attrs:{"items":_vm.fulfillmentTypeList,"itemText":"friendly","placeholder":"Fulfillment Type","outlined":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'AutocompleteBase',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }